module.exports = __webpack_public_path__ + "static/img/tip.122df750.jpg";